'use strict';

const jQuery = require('jquery');

const Translator = require('./../../../../core/translator');
const Container = require('./../../../../core/container');

const designRepo = require('./../../repository/DesignRepository');

const zone = require('./../../../../services/structure/zone');
const fixHeight = require('./../../../../services/fixHeight');
const FormBuilder = require('./../../../../services/form');
const Notifier = require('./../../../../services/notifier');
const Loader = require('./../../../../services/loader');

const getOptions = function(data) {
   let options = {};

   data.forEach((element, index)=>{
      (typeof(element) === 'object') ? options[index] = element.label : options[index] = element;
   });

   return options;
};

module.exports.onClick = function() {
   let $container = jQuery('<div class="button-settings-panel"></div>');

   let $layer = zone.addLayer(Translator.translate('button_settings'), $container);

   let fonts = designRepo.getStaticAllFonts().map((element)=> element);
   let shapes = designRepo.getStaticAllShapes();

   fonts.unshift({
      'label': Translator.translate('default_font'),
      'value': null,
   });

   Loader.start($layer);
   designRepo.getBtnSettings().done(function(data) {
      let selectedFont = fonts.map((font)=> font.value).indexOf(data.font);

      let elements = {
         'fontStyle': {
            'label': 'font_style',
            'type': 'select',
            'value': selectedFont.toString(),
            'options': getOptions(fonts),
         },
         'btnShape': {
            'label': 'button_style',
            'type': 'select',
            'value': shapes.indexOf(data.shape).toString(),
            'options': getOptions(shapes),
         },
      };

      let form = FormBuilder.getForm({
         'elements': elements,
         'form': {
            'submit_class': 'd-none',
         },
      });

      $container.append(form.render());
      Loader.stop($layer);

      form.on('submit', (data) => {
         let btnSettings = {
            'font': fonts[data.fontStyle].value,
            'shape': shapes[data.btnShape],
         };

         zone.hidePanels(Container.get('$smallPanel'));
         designRepo.updateBtnSettings(btnSettings).done(function() {
            Notifier.success(Translator.translate('parameters_saved'));
            location.reload();
         });
      });

      zone.setFooter($layer, zone.createSubmitButtons({
         onSubmitClick: form.submit.bind(form),
      }));

      fixHeight.fix($container, jQuery(window).height() - 165);
   });
};
